import React from 'react';
import { APP_TYPE_AGENCY } from '../../src/config/constant';
import { APPLICATION_TYPE } from '@src/config/ph/constant';

export const APPLICATION_TYPE_CHIPS = [
    { key: 'b2c', label: 'B2C' },
    { key: 'b2b2c', label: 'B2B2C' },
];

export const getApplicationTypeMap = (masterConfig: any = {}) => {
    const leadTypes = Array.isArray(masterConfig?.lead_types) ? masterConfig.lead_types : [];
    const normalizeLabel = (value: any) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const getValuesByLabels = (labels: string[], fallbackValues: number[]) => {
        const normalizedLabels = labels.map(normalizeLabel);
        const matchedValues = leadTypes
            .filter((type: any) => {
                const optionLabels = [
                    normalizeLabel(type?.label),
                    normalizeLabel(type?.name),
                    normalizeLabel(type?.slug),
                    normalizeLabel(type?.key),
                ];
                return optionLabels.some((optionLabel) => normalizedLabels.includes(optionLabel));
            })
            .map((type: any) => type?.value)
            .filter((value: any) => value !== undefined && value !== null);

        return matchedValues.length > 0 ? matchedValues : fallbackValues;
    };

    return {
        b2c: getValuesByLabels(['renewal', 'uc', 'standalone'], APPLICATION_TYPE.B2B),
        b2b2c: getValuesByLabels(['agency'], [APP_TYPE_AGENCY]),
    };
};

export const getFiltersWithApplicationType = (
    filters: Record<string, any> = {},
    applicationType: string,
    applicationTypeMap: Record<string, any[]> = {}
) => {
    const filtersWithApplicationType = { ...filters };
    const applicationTypes = applicationTypeMap[applicationType] || [];

    if (applicationTypes.length > 0) {
        filtersWithApplicationType.application_type = applicationTypes;
    } else {
        delete filtersWithApplicationType.application_type;
    }

    return filtersWithApplicationType;
};

export const getApplicationTypeChipCount = (paginationData: any = {}, chipKey: string, selectedApplicationType = '') => {
    const countKeyMap: Record<string, string[]> = {
        b2c: ['b2b_count', 'b2c_count', 'b2c_remittance_count', 'b2c_total'],
        b2b2c: ['b2b2c_count', 'b2b2c_remittance_count', 'b2b2c_total', 'agency_count']
    };
    const countKey = countKeyMap[chipKey]?.find((key) => paginationData?.[key] !== undefined);

    if (countKey) {
        return paginationData[countKey];
    }

    return selectedApplicationType === chipKey ? paginationData?.total ?? 0 : 0;
};

const formatChipCount = (count: any) => {
    const numericCount = Number(count || 0);
    return Number.isFinite(numericCount) ? numericCount.toLocaleString('en-US') : '0';
};

const ApplicationTypeChips: React.FC<any> = ({
    selectedApplicationType,
    paginationData,
    onChange,
    label = 'APPLICATION',
}) => (
    <div className="lead-view-chip-outer">
        <span className="lead-view-label">{label}</span>
        <div className="lead-view-chip-list">
            {APPLICATION_TYPE_CHIPS.map((chip) => (
                <button
                    key={chip.key}
                    type="button"
                    className={`lead-view-chip ${selectedApplicationType === chip.key ? 'active' : ''}`}
                    onClick={() => onChange(chip.key)}
                >
                    {chip.label}
                    <span>{formatChipCount(getApplicationTypeChipCount(paginationData, chip.key, selectedApplicationType))}</span>
                </button>
            ))}
        </div>
    </div>
);

export default ApplicationTypeChips;
